import $ from "jquery";
import 'bootstrap-icons/font/bootstrap-icons.css';
var dataTable;
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "materialIndex")
        return;
});
//# sourceMappingURL=materialIndex.js.map